import { useLanguage } from "@/context/LanguageContext";

export const Marquee = () => {
  const { t } = useLanguage();
  const words = [...t.marquee, ...t.marquee, ...t.marquee];
  return (
    <div data-testid="editorial-marquee" className="border-y border-coal bg-ink py-6 overflow-hidden select-none">
      <div className="marquee-track flex items-center gap-10">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-10 shrink-0">
            {words.map((w, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-10">
                <span className="font-serif text-2xl md:text-3xl italic text-ivory/80 whitespace-nowrap">{w}</span>
                <span className="h-2 w-2 rotate-45 bg-bronze shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
